export default __webpack_public_path__ + "static/media/payment-security.0c966476.svg";